import { render, staticRenderFns } from "./MassRollCallSection.vue?vue&type=template&id=319e874c&scoped=true"
import script from "./MassRollCallSection.vue?vue&type=script&lang=js"
export * from "./MassRollCallSection.vue?vue&type=script&lang=js"
import style0 from "./MassRollCallSection.vue?vue&type=style&index=0&id=319e874c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e874c",
  null
  
)

export default component.exports